import { ServiceTypeConstants } from '../constants/serviceType.constants';
import { CounsellorsService } from '../../services';


export const serviceTypeActions = {
	fetchServiceType,
		
};

function fetchServiceType() {
	return (dispatch) => {
		dispatch(request());
		CounsellorsService.fetchServiceType().then(
			(serviceType) => {
				dispatch(success(serviceType));
			},
			(error) => dispatch(failure(error.toString()))
		);
	};
}

function request() {
	return { type: ServiceTypeConstants.GET_SERVICE_TYPE_REQUEST };
}

function success(data) {	
		return { type: ServiceTypeConstants.GET_SERVICE_TYPE_SUCCESS, data };
}

function failure(error) {
	return { type: ServiceTypeConstants.GET_SERVICE_TYPE_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/store/actions/serviceType.actions.js